import { render, staticRenderFns } from "./CaseCustomMenus.vue?vue&type=template&id=c24eb644&scoped=true&"
import script from "./CaseCustomMenus.vue?vue&type=script&lang=js&"
export * from "./CaseCustomMenus.vue?vue&type=script&lang=js&"
import style0 from "./CaseCustomMenus.vue?vue&type=style&index=0&id=c24eb644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24eb644",
  null
  
)

export default component.exports